enum HttpHeader {
    AccessToken = "Access-Token",
    UserId = "Uid",
    Version = "Version",
}

export default HttpHeader;
